// material-ui
import { useTheme, styled } from '@mui/material/styles';
import {
    Avatar,
    Button,
    Divider,
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    Typography
} from '@mui/material';

import { formatDateDMY } from 'styles/commonFunction';
import { useState } from 'react';
import ClientChangeActivityLogModal from 'views/admin-components/pages/ClientActivityChangeLogModal';

// styles
const ListItemWrapper = styled('div')(({ theme }) => ({
    // cursor: 'pointer',
    padding: 16,
    '&:hover': {
        background: theme.palette.primary.light
    },
    '& .MuiListItem-root': {
        padding: 0
    }
}));

// ==============================|| NOTIFICATION LIST ITEM ||============================== //

const NotificationList = ({ notificationData }) => {
    const theme = useTheme();
    const [open, setOpen] = useState();
    const [notificationId, setNotificationId] = useState();

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const viewChange = async (id) => {

        setNotificationId(id)
        handleClickOpen();
    }

    const ManagerChangeLogPopup = () => {
        return (
            <div>
                <ClientChangeActivityLogModal handleClose={handleClose} open={open} id={notificationId} />
            </div>
        );
    };

    return (
        <>
            <List
                sx={{
                    width: '100%',
                    py: 0,
                    borderRadius: '10px',
                    [theme.breakpoints.down('md')]: {
                        maxWidth: 300
                    },
                    '& .MuiListItemSecondaryAction-root': {
                        top: 22
                    },
                    '& .MuiDivider-root': {
                        my: 0
                    },
                    '& .list-container': {
                        pl: 0
                    }
                }}
            >

                {notificationData ? notificationData?.map((row, index) => {

                    return (
                        <>
                            <ListItemWrapper>
                                <ListItem alignItems="center">

                                    <ListItemAvatar>
                                        <Avatar sx={{ backgroundColor: row?.color_code, fontSize: '15px', color: '#fff' }}>
                                            {row?.first_name?.charAt(0)}
                                            {row?.last_name ? row.last_name?.charAt(0) : ''}
                                        </Avatar>
                                    </ListItemAvatar>

                                    <ListItemText primary={<Typography variant="subtitle1">
                                        {row?.first_name} {' '}
                                        {row?.last_name ? row.last_name : ''}
                                    </Typography>} />

                                    <ListItemSecondaryAction>
                                        <Grid container justifyContent="flex-end">
                                            <Grid item xs={12} sx={{ paddingTop: '0px' }}>
                                                <Typography variant="subtitle1" display="block" gutterBottom>
                                                    {formatDateDMY(row.created_at)}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </ListItemSecondaryAction>

                                </ListItem>

                                <Grid container spacing={2} direction="row" className="mt-1" sx={{ padding: '0px' }}>

                                    <Grid item xs={9} sx={{ pt: 0 }}>
                                        <Typography component="span" variant="body2">
                                            {row.message}
                                        </Typography>
                                    </Grid>
                                    {
                                        !row.hide_view_button ?
                                            <Grid item xs={3} sx={{ pt: 0 }}><Button variant="outlined" sx={{ padding: '0px' }} size="small" onClick={() => viewChange(row.id)}>View</Button></Grid>
                                            : ""
                                    }

                                </Grid>
                            </ListItemWrapper>
                            <Divider />
                        </>
                    )
                })
                    : 'No data found'
                }
            </List >
            {/* <ManagerChangeLogPopup /> */}
            {ManagerChangeLogPopup()}
        </>
    );
};

export default NotificationList;
